import {ICellRenderer} from 'ag-grid-community';
import {Tooltip} from 'platform/components';
import {Box, Icon} from 'platform/foundation';

import {forwardRef} from 'react';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRendererParams} from '../../types/AgGridTypes';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getUnformattedValue} from '../../utils/getUnformattedValue';

export interface CheckboxCellRendererParams extends ICellRendererParams {
  getTooltipProps?: TooltipGetter;
}

function CheckboxCellRendererComponent(
  props: CheckboxCellRendererParams,
  _ref: React.Ref<ICellRenderer>
) {
  const tooltipProps = useTooltipProps(props.data, props.node, props.getTooltipProps);
  const isTruthy = !!getUnformattedValue(props);

  return (
    <Tooltip {...tooltipProps}>
      <Box css={{display: 'inline-flex'}}>
        {isTruthy ? (
          <Icon value="action/check_circle" size={6} color="severity.success" />
        ) : (
          <Icon value="navigation/cancel" size={6} color="severity.danger" />
        )}
      </Box>
    </Tooltip>
  );
}

export const CheckboxCellRenderer = forwardRef<ICellRenderer, CheckboxCellRendererParams>(
  CheckboxCellRendererComponent
);
